import { CSS_VARS as n } from "../constants.js";
import { getCssVar as o } from "./helpers.js";
function a(r) {
  const e = isNaN(parseFloat(o(n.GRID_GUTTER))) ? 0 : parseFloat(o(n.GRID_GUTTER)), t = r == null ? void 0 : r.getBoundingClientRect();
  if (t)
    return Math.round(t.left) < e ? {
      value: e - Math.round(t.left),
      side: "left"
    } : Math.round(t.right) > document.documentElement.clientWidth - e ? {
      value: Math.round(t.right) - (document.documentElement.clientWidth - e),
      side: "right"
    } : {
      side: "",
      value: 0
    };
}
export {
  a as default
};
//# sourceMappingURL=calculateElementOverflow.js.map
